<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="container-fluid">
  <div class="container space-1 space-md-2">
    <div class="row">
      <div class="col-lg-4 order-lg-2 mb-7 mb-lg-0">
        <div class="pl-lg-4">
          <!-- Order Summary -->
          <div class="border shadow-soft rounded p-5 mb-4">
            <!-- Title -->
            <div class="border-bottom pb-4 mb-4">
              <h2 class="h5 mb-0">Order summary</h2>
            </div>
            <!-- End Title -->

            <!-- Product Content -->
            <div *ngFor="let item of cart.items" class="border-bottom pb-4 mb-4">
              <div class="media">
                <div class="position-relative max-width-10 w-100 mr-3">
                  <img class="img-fluid" src="/fetchimage?fileName={{ item.product.marketingSplash }}&mode=crop&width=300&height=180" [fallback]="'https://bxlimages.blob.core.windows.net/splash/noimage.png'"  />
                  <span class="badge badge-sm badge-primary badge-pos rounded-circle">{{ item.qty }}</span>
                </div>
                <div class="media-body">
                  <h2 class="h6">{{ item.product.title }}</h2>

                  <ng-container *ngIf="item.product.isBooth">
                    <div class="text-secondary font-size-1 mb-1">
                      <span>Booth: {{ item.variationName }}</span>
                    </div>
                  </ng-container>
                  <p class="text-danger">{{ item.errorMessage }}</p>
                </div>
              </div>
              <div *ngFor="let addon of item.selectedAddons" class="text-secondary font-size-1 mb-1">
                <span>Add-On: {{ addon.title }} </span>
              </div>
            </div>
            <!-- End Product Content -->

            <!-- Fees -->
            <div class="border-bottom pb-4 mb-4">
              <div class="media align-items-center mb-3">
                <h3 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Item subtotal ({{ cart.totalItems }})</h3>
                <div class="media-body text-right">
                  <span class="font-weight-medium">{{ cart.cartTotal | currency: conference.sponsorCurrency }}</span>
                </div>
              </div>

              <div class="media align-items-center mb-3">
                <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Delivery</h4>
                <div class="media-body text-right">
                  <span class="font-weight-medium">Electronic</span>
                </div>
              </div>
            </div>
            <!-- End Fees -->
            <ng-container *ngIf="!model.isPurchaseOrder && !settings.allowCreditCardsForSponsorships; else default">
            <div class="media align-items-center">
              <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Processing Fee</h4>
              <div class="media-body text-right">
                <span class="font-weight-semi-bold">{{ creditCardFee | currency: conference.sponsorCurrency }}</span>
              </div>
            </div>
            <div class="media align-items-center">
              <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Total</h4>
              <div class="media-body text-right">
                <span class="font-weight-semi-bold">{{ adjustedTotal + creditCardFee | currency: conference.sponsorCurrency }}</span>
              </div>
            </div>
            </ng-container>
            <!-- Total -->
            <ng-template #default>
            <div class="media align-items-center">
              <h4 class="text-secondary font-size-1 font-weight-normal mb-0 mr-3">Total</h4>
              <div class="media-body text-right">
                <span class="font-weight-semi-bold">{{ adjustedTotal | currency: conference.sponsorCurrency }}</span>
              </div>
            </div>
            </ng-template>
            <!-- End Total -->
          </div>
          <!-- End Order Summary -->

          <!-- Accordion -->
          <div id="shopCartAccordion" class="accordion rounded shadow-soft mb-4">
            <!-- Card -->
            <div class="card rounded">
              <div class="card-header card-collapse" id="shopCartHeadingOne">
                <h3 class="mb-0">
                  <button type="button" class="btn btn-link btn-block card-btn font-weight-medium collapsed" data-toggle="collapse" data-target="#shopCartOne" aria-expanded="false" aria-controls="shopCartOne">
                    Promo code?
                    <span class="far fa-question-circle text-secondary ml-1" data-container="body" data-toggle="popover" data-placement="top" data-trigger="hover" title="" data-content="Valid on full priced items only. Some products maybe excluded." data-original-title="Promo code"></span>
                  </button>
                </h3>
              </div>
              <div id="shopCartOne" class="collapse" aria-labelledby="shopCartHeadingOne" data-parent="#shopCartAccordion">
                <form class="js-validate p-5" novalidate="novalidate">
                  <div class="input-group input-group-pill mb-3">
                    <input type="text" class="form-control" [(ngModel)]="promoCode" name="promoCode" placeholder="Promo code" aria-label="Promo code" />
                    <div class="input-group-append">
                      <button type="submit" (click)="applyPromoCode()" class="btn btn-block btn-primary btn-pill transition-3d-hover">Apply</button>
                    </div>
                  </div>
                  <div *ngIf="promoError" class="invalid-message-visible">
                    <div>{{ promoError }}</div>
                  </div>
                </form>
              </div>
            </div>
            <!-- End Card -->
          </div>
          <!-- End Accordion -->
        </div>
      </div>

      <div class="col-lg-8 order-lg-1">
        <div *ngIf="errorMessage" class="alert alert-primary" role="alert" [innerHTML]="errorMessage"></div>
        <form #myForm="ngForm" class="form" (submit)="submit()">
          <div *ngIf="!auth.isLoggedIn()" class="text-center mb-3">
            <h4>You not are logged in.</h4>
            <p>Please login or create an account to track this purchase and future correspondence.</p>
            <button type="button" (click)="navService.showLogin()" class="btn btn-primary">Login/Sign-Up</button>
            <div class="d-block mt-2">
              <a [routerLink]="['../cart']"><small class="fas fa-arrow-left mr-2"></small> Return to cart</a>
            </div>
          </div>

          <ng-container *ngIf="auth.isLoggedIn()">
            <div>
              <div class="alert alert-heading text-center">
                <img class="img-fluid rounded-circle" style="width:100px;" [fallback]="'fetch-avatar?userId=' + auth.user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ auth.user.id }}-avatar.png"  />
                <h4>You are logged in as {{ auth.user.firstName + ' ' + auth.user.lastName }}</h4>
                <p>All future correspondence will be tied to this account.</p>
                <a href="javascript:void(0)" (click)="navService.reLogin()">Login with a different account</a>
              </div>
            </div>

            <div class="border-bottom pb-3 mb-3">
              <!-- Title -->
              <div class="mb-4">
                <h2 class="h4">User Information</h2>
              </div>

              <!-- End Title -->

              <!-- Billing Form -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Input -->
                  <div class="js-form-message mb-6">
                    <label class="form-label">
                      Company Name
                      <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" [(ngModel)]="model.companyName" name="firstName" placeholder="Acme Company" required />
                    <div class="invalid-message">
                      <div>Company Name is required</div>
                    </div>
                  </div>
                  <!-- End Input -->
                </div>

                <div class="col-md-6">
                  <!-- Input -->
                  <div class="js-form-message mb-6">
                    <label class="form-label"> Phone </label>
                    <input type="text" class="form-control" [(ngModel)]="model.phoneNumber" name="phoneNumber" required placeholder="+1 (062) 109-9222" />
                    <div class="invalid-message">
                      <div>Phone Number is required</div>
                    </div>
                  </div>
                  <!-- End Input -->
                </div>
              </div>
              <!-- End Billing Form -->
            </div>

            <!-- Payment -->
            <div class="mb-7">
              <ng-container *ngIf="adjustedTotal > 0">
                <!-- Title -->
                <div class="mb-4">
                  <h2 class="h4">Payment method</h2>
                </div>
                <!-- End Title -->

                <div class="row mb-2">
                  <div class="col-md-12 col-lg-6">
                    <label for="inputAddress">Payment Method</label>
                    <select class="form-control" required [(ngModel)]="model.isPurchaseOrder" name="isPurchaseOrder">
                      <option [ngValue]="false">Credit Card <span *ngIf="!settings.allowCreditCardsForSponsorships">+3% Fee</span></option>
                      <option *ngIf="conference.id != 296" [ngValue]="true">Check/EFT/Purchase Order</option>
                    </select>
                    <div class="invalid-message">Payment Method is Required</div>
                  </div>
                </div>
                <div class="row" *ngIf="!model.isPurchaseOrder">
                  <div class="col-md-12 col-lg-6">
                    <label> Card Number </label>
                    <input type="text" [(ngModel)]="cardNumber" name="cardNumber" class="form-control" name="cardNumber" placeholder="**** **** **** ***" required />
                    <div class="invalid-message">
                      <div>Card Number is required</div>
                    </div>
                  </div>

                  <div class="col-md-4 col-lg-2">
                    <label for="uname1">Month</label>
                    <select class="form-control" [(ngModel)]="expMo" name="expMo" required>
                      <option value="1">01 - January</option>
                      <option value="2">02 - February</option>
                      <option value="3">03 - March</option>
                      <option value="4">04 - April</option>
                      <option value="5">05 - May</option>
                      <option value="6">06 - June</option>
                      <option value="7">07 - July</option>
                      <option value="8">08 - August</option>
                      <option value="9">09 - September</option>
                      <option value="10">10 - October</option>
                      <option value="11">11 - November</option>
                      <option value="12">12 - December</option>
                    </select>
                    <div class="invalid-message">
                      <div>Month is required</div>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <label for="uname1">Year</label>
                    <select class="form-control" [(ngModel)]="expYr" name="expYr" required>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                      <option value="2031">2031</option>
                      <option value="2032">2032</option>
                      <option value="2033">2033</option>
                      <option value="2034">2034</option>
                    </select>
                    <div class="invalid-message">
                      <div>Year is required</div>
                    </div>
                  </div>

                  <div class="col-md-4 col-lg-2">
                    <!-- Input -->
                    <div>
                      <label> CVC </label>
                      <input type="text" [(ngModel)]="cvv" name="cvv" required class="form-control" placeholder="***" />
                      <div class="invalid-message">
                        <div>CVV is required</div>
                      </div>
                    </div>
                    <!-- End Input -->
                  </div>
                </div>
              </ng-container>
              <div class="mt-2"><small>{{conference.shortName}} reserves the right to review and approve all exhibit and sponsorship applications and purchases at its sole discretion. Should your application/purchase be declined, you will be notified, and any payments made will be refunded in full prior to the conference.</small></div>
              <!-- Button -->
              <div class="d-flex justify-content-between align-items-center mt-3">
                <a [routerLink]="['../cart']"><small class="fas fa-arrow-left mr-2"></small> Return to cart</a>
                <button type="submit" [promiseBtn]="submitComplete" class="btn btn-primary btn-sm-wide btn-pill transition-3d-hover">Place order</button>
              </div>

              <!-- End Button -->
            </div>
            <!-- End Payment -->
          </ng-container>
        </form>
      </div>
    </div>
  </div>
</div>
